import { useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { gql } from "@apollo/client";
import {
  useFeatureFlags,
  useNorthbeamQuery,
  useUpdateUserFeatureFlag,
} from "@hooks/http";
import { type GetDevelopmentTables } from "@north-beam/nb-client-side";

export const usePrefs = () => {
  const { hasFeatureFlag } = useFeatureFlags();
  const [updateUserFeatureFlag] = useUpdateUserFeatureFlag();
  const { data, loading } =
    useNorthbeamQuery<GetDevelopmentTables>(DEV_TABlES_QUERY);

  const [developmentTable, setDevelopmentTable] = useLocalStorage<
    string | null
  >("developmentDataset", "development");

  return useMemo(() => {
    return {
      developmentTable,
      setDevelopmentTable,
      availableDevelopmentTables: data?.me.availableDevelopmentTables || [],
      availableDevelopmentTablesLoading: loading,
      async setDemoMode(value: boolean) {
        await updateUserFeatureFlag("demoMode", value);
      },

      isDemoMode: hasFeatureFlag("demoMode"),
      async setUseDevelopmentAnalyticsData(value: boolean) {
        await updateUserFeatureFlag("useDevelopmentAnalyticsData", value);
      },

      useDevelopmentAnalyticsData: hasFeatureFlag(
        "useDevelopmentAnalyticsData",
      ),
    };
  }, [
    developmentTable,
    setDevelopmentTable,
    data?.me.availableDevelopmentTables,
    loading,
    hasFeatureFlag,
    updateUserFeatureFlag,
  ]);
};

const DEV_TABlES_QUERY = gql`
  query GetDevelopmentTables {
    me {
      id
      availableDevelopmentTables
    }
  }
`;
